export const getLanguageCountryStepStyles = () => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  containerWithBusinessInfo: {
    '& .header-title': {
      marginBottom: '20px',
    },
    '& .section-subtitle': {
      alignSelf: 'start',
    },
    '& .language-country-container': {
      maxWidth: '600px',
      padding: '10px 0',
      alignSelf: 'start',
      '& .language-selection-container': {
        marginBottom: '0px',
      },
    },
    '& .collect-business-info-container': {
      width: '100%',
      '& .form-group': {
        marginBottom: '0px',
      },
      '& .terms-and-conditions-container': {
        '& .tc-validation-note': {
          color: '#A80000',
          fontSize: '12px',
        },
      },
    },
  },
});
